// Thin FontAwesome wrappers so the rest of the app keeps using <Phone />,
// <Mail />, etc. without caring about the underlying icon library.
import { FontAwesomeIcon, type FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { cn } from '@/lib/cn';
import '@/lib/fa';

type Props = Omit<FontAwesomeIconProps, 'icon'> & { className?: string };

const make =
  (name: FontAwesomeIconProps['icon']) =>
  ({ className, ...rest }: Props) =>
    <FontAwesomeIcon icon={name} className={cn(className)} {...rest} />;

export const Phone = make(['fas', 'phone']);
export const PhoneVolume = make(['fas', 'phone-volume']);
export const Mail = make(['fas', 'envelope']);
export const MapPin = make(['fas', 'location-dot']);
export const Menu = make(['fas', 'bars']);
export const X = make(['fas', 'xmark']);
export const ChevronDown = make(['fas', 'chevron-down']);
export const ChevronRight = make(['fas', 'chevron-right']);
export const ChevronLeft = make(['fas', 'chevron-left']);
export const Check = make(['fas', 'check']);
export const ArrowRight = make(['fas', 'arrow-right']);
export const Shield = make(['fas', 'shield']);
export const Star = make(['fas', 'star']);
export const Trowel = make(['fas', 'trowel']);
export const HelmetSafety = make(['fas', 'helmet-safety']);
export const House = make(['fas', 'house']);
export const Road = make(['fas', 'road']);
export const Tree = make(['fas', 'tree']);
export const Droplet = make(['fas', 'droplet']);
export const SprayCan = make(['fas', 'spray-can-sparkles']);
export const Clock = make(['fas', 'clock']);
export const Briefcase = make(['fas', 'briefcase']);
export const Award = make(['fas', 'award']);
export const SignOut = make(['fas', 'right-from-bracket']);
export const Warning = make(['fas', 'triangle-exclamation']);
export const Google = make(['fab', 'google']);
export const Code = make(['fas', 'code']);
export const Facebook = make(['fab', 'facebook-f']);
export const TwitterX = make(['fab', 'x-twitter']);
export const TikTok = make(['fab', 'tiktok']);
export const WhatsApp = make(['fab', 'whatsapp']);
export const QuoteLeft = make(['fas', 'quote-left']);
export const Message = make(['fas', 'message']);
export const Plus = make(['fas', 'plus']);
export const CommentDots = make(['fas', 'comment-dots']);

// Spinner with auto-spin animation.
export const Loader = ({ className, ...rest }: Props) => (
  <FontAwesomeIcon icon={['fas', 'circle-notch']} className={cn('animate-spin', className)} {...rest} />
);
